'use client'

import { useSearchParams } from 'next/navigation'
import { useSyncExternalStore } from 'react'

import { isConnectAuthFlow, readSignupFlow } from './signup-flow'

const subscribeNever = () => () => {}
const getServerSnapshot = () => undefined

/** Reuse the signup marker and the auth entry's existing return destination. */
export function useConnectAuth() {
  const params = useSearchParams()
  // Match the server during hydration, then read the browser's signup cookie.
  const flow = useSyncExternalStore(
    subscribeNever,
    readSignupFlow,
    getServerSnapshot,
  )
  return isConnectAuthFlow(params.get('redirect_url'), flow)
}
